jQuery(document).ready(function () {
  if (jQuery('#temoignages').length > 0) {
    const container = document.querySelector('#temoignages .slider-temoignages-clients');
    const slides = container.querySelectorAll('.swiper-slide');
    const totalSlides = slides.length;
    let currentIndex = 0;
    let autoplayInterval = null;
    function updateSlider(index) {
      currentIndex = index;
      // Update active classes
      slides.forEach(function (s, i) {
        s.classList.toggle('swiper-slide-active', i === index);
        s.classList.toggle('swiper-slide-prev', i === index - 1);
        s.classList.toggle('swiper-slide-next', i === index + 1);
      });
      // Calculate offset: each inactive slide = 15% of container + 30px gap
      var containerWidth = container.clientWidth;
      var inactiveWidth = containerWidth * 0.15;
      var gap = 30;
      var offset = 0;
      for (var i = 0; i < index; i++) {
        offset += inactiveWidth + gap;
      }
      // Apply offset via margin-left on first slide
      slides[0].style.marginLeft = -offset + 'px';
      slides[0].style.transition = 'margin-left 0.3s ease, width 0.3s ease';
      // Update button states
      var prevBtn = document.querySelector('#temoignages .swiper-button-prev');
      var nextBtn = document.querySelector('#temoignages .swiper-button-next');
      if (prevBtn) prevBtn.classList.toggle('swiper-button-disabled', index === 0);
      if (nextBtn) nextBtn.classList.toggle('swiper-button-disabled', index >= totalSlides - 1);
    }
    // Navigation buttons
    var prevBtn = document.querySelector('#temoignages .swiper-button-prev');
    var nextBtn = document.querySelector('#temoignages .swiper-button-next');
    if (prevBtn) {
      prevBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (currentIndex > 0) updateSlider(currentIndex - 1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (currentIndex < totalSlides - 1) updateSlider(currentIndex + 1);
      });
    }
    // Autoplay
    function startAutoplay() {
      autoplayInterval = setInterval(function () {
        if (currentIndex < totalSlides - 1) {
          updateSlider(currentIndex + 1);
        } else {
          updateSlider(0);
        }
      }, 5000);
    }
    function stopAutoplay() {
      if (autoplayInterval) clearInterval(autoplayInterval);
    }
    // Pause autoplay on hover
    container.addEventListener('mouseenter', stopAutoplay);
    container.addEventListener('mouseleave', startAutoplay);
    // Initialize
    updateSlider(0);
    startAutoplay();
  }
});
